import { render } from "./StrategyDeleteModal.vue?vue&type=template&id=2c9ff429"
import script from "./StrategyDeleteModal.vue?vue&type=script&lang=js"
export * from "./StrategyDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__